import toggle from './toggle';

export default {
  'sa-aside-toggle': toggle, 
};
